import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/clients",

        async total() {
            const url = this.userUrl({ path: `/total` });

            return Vue.http.get(url);
        },

        listMacByClient({ id, search }) {
            this.apiUrl = "/cliente";
            const url = this.url(`/${id}/mac/list`);

            return Vue.http.get(url, { params: { search } });
        },
    },
    base
);
